import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import Helpers from '@intelingu/core/helpers/Helpers';
import { lazyInject } from '@intelingu/core/IoC/container';
import { CourseStore } from '@intelingu/core/stores/CourseStore';
import Select, { components } from 'react-select';

interface CoursesSelectProps {
    defaultValue;
    onChange;
    addOther?: boolean;
}

@observer export class CoursesSelect extends Component<CoursesSelectProps, any> {

    @lazyInject(CourseStore) courseStore: CourseStore;

    @computed get options() {
        const result = this.courseStore.coursesList.map(course => ({
            label: course.name,
            code: course.translation_language,
            icon: course.icon,
            value: course.id
        }));

        if (this.props.addOther) {
            result.push({
                label: 'andere Sprache',
                code: null,
                icon: null,
                value: null
            })
        }

        return result;
    }

    customOption = (props) => (
        <components.Option {...props}>
            { this._renderSelectFlag(props) }
            { props.data.label }
        </components.Option>
    );

    singleValue = (props) => (
        <components.SingleValue {...props}>
            { this._renderSelectFlag(props) }
            { props.children }
        </components.SingleValue>
    );

    _renderSelectFlag = (props) => {
        if (!props.data.icon) {
            return <span />;
        }

        return <img
            src={props.data.icon}
            alt={props.data.code}
            className={'mr-2'}
            width={17}
        />
    };

    render() {
        return <Select
            options={this.options}
            placeholder={'Auswählen...'}
            components={{ Option: this.customOption, SingleValue: this.singleValue }}
            value={Helpers.getSelectValue(this.options, this.props.defaultValue)}
            onChange={value => {
                if (!value.value) {
                    Object.assign(document.createElement('a'), { target: '_blank', href: 'https://home.intelingu.com/welche-sprache-willst-du-mit-intelingu-lernen/'}).click();
                    return;
                }

                this.props.onChange(value.value);
            }}
        />
    }

}
